import React from 'react';
import { Select } from 'antd';
import { Form as LegacyForm } from '@ant-design/compatible';
import { CarbonIconType } from '@carbon/icons-react';
import history from '../../../core/utils/history';

interface ReportSelectFilterProps {
    reportOptions: {
        id: number,
        link: string,
        title: string,
        description: string,
        icon: CarbonIconType,
    }[];
}

/**
 * Dropdown for selecting report type. Varies from typical sidebars because it navigates on select.
 */
const ReportSelectFilter: React.FC<ReportSelectFilterProps> = ({ 
    reportOptions,
}) => {
    return (
        <LegacyForm 
            layout="vertical"
            onSubmit={() => {}}
        >
            <LegacyForm.Item label="Report Type">
                <Select
                    allowClear
                    showSearch
                    filterOption={(txt, obj) => (obj?.props?.children?.toLowerCase().includes(txt.toLowerCase()))}
                    placeholder="Select Report Type"
                    onChange={val => history.push(`/reports/${val}`)}
                    data-testid='report-select-filter_type-select'
                >
                        {reportOptions.sort((a,b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0).map(report => (
                            <Select.Option
                                key={`report-option-${report.id}`}
                                value={report.link}
                                data-testid='report-select-filter_type-option'
                            >
                                {report.title}
                            </Select.Option>
                        ))}
                </Select>
            </LegacyForm.Item>
        </LegacyForm>
    );
}

export default ReportSelectFilter;
